import type {ReactNode} from 'react'
import {SanityImage} from '../sanityImage/SanityImage'
import Link from 'next/link'
import {SocialsLogo} from '../socialsLogo/SocialsLogo'

export interface PersonCardProps {
	children: ReactNode
	className: string
}

export const PersonCard = ({media, personName, socialLinks, slug, quote, company}) => {
	return (
		<div className='grid-container bg-[#FCF9ED] span-w-6 lg:span-w-10 mb-48'>
			<div className='flex flex-col lg:flex-row'>
				<SanityImage className='object-cover span-w-6 lg:w-330' image={media} desktopWidth={330} />
				<div className='flex flex-col mt-30 lg:mt-32 ml-19 lg:mx-64 lg-max:span-w-5'>
					<h2 className='mb-16 lg:mb-24 leading-tight text-22 lg:text-42 lg:w-620 lg-max:text-[#170600]'>{quote}</h2>
					<h3 className='text-20'>{personName}</h3>
					<div className='flex content-between mt-22'>
						{socialLinks &&
							<div id='socials' className=''>
								<h6 className='text-18 color-[#454545] opacity-50 mb-12 lg-max:hidden'>Socials</h6>
								<div className='flex flex-row pb-15'>
									{socialLinks?.map((item, idx) => (
										<Link href={item.url} key={idx} className='w-24 h-24 mr-16'>
											<SocialsLogo {...item} />
										</Link>
									))}

								</div>
							</div>}
						<Link href={`/article/${slug.en.current}`} id='footer-cta' className='lg-max:hidden group flex items-center content-center text-13 rounded-full  py-15  px-40 ml-auto w-fit h-fit text-center text-[#2e2e2e] bg-[#454545]'>
							<div id='footer-cta--inner' className='relative overflow-hidden text-white'>
								<div id='footer-cta--before' className='group-hover:translate-y-[-150%] transition-transform duration-500 ease-out-expo '>Read Article</div>
								<div id='footer-cta--after' className='absolute group-hover:translate-y-0 transition-transform duration-500 ease-out-expo translate-y-[150%] bottom-0'>Read Article</div>
							</div>
						</Link>
					</div>
				</div>
			</div>
			<Link href={`/article/${slug.en.current}`} id='footer-cta' className='lg:hidden mb-20 group flex items-center content-center text-13 rounded-full  py-15  px-40 mx-auto w-fit h-fit text-center text-[#2e2e2e] bg-[#454545]'>
				<div id='footer-cta--inner' className='relative overflow-hidden text-white'>
					<div id='footer-cta--before' className='group-hover:translate-y-[-150%] transition-transform duration-500 ease-out-expo '>Read Article</div>
					<div id='footer-cta--after' className='absolute group-hover:translate-y-0 transition-transform duration-500 ease-out-expo translate-y-[150%] bottom-0'>Read Article</div>
				</div>
			</Link>
			{company &&
				<div className='lg:py-40 flex lg:flex-row flex-col text-[#454545]'>

					{company?.logo && <SanityImage className='object-contain span-w-6 lg:w-330 lg-max:px-33 lg-max:pt-20 lg-max:mb-15 lg:px-20 h-140' image={company.logo} desktopWidth={330} />}
					<div id='companyDetails' className='flex flex-col lg:pl-64 '>
						<Link className='underline border-black md-max:text-center md-max:mx-auto lg-max:pb-20 lg-max:border-b text-21 lg:text-36 mb-28 lg:mb-44 border-opacity-40' href={company.website.url}>{company.website.url.replace(/^https?:\/\//, '')}</Link>
						<div className='flex flex-col lg:flex-row lg-max:text-center lg-max:mx-auto'>
							{company.contact &&
								<div className='flex flex-col lg:mr-30'>
									<div className='mb-12 opacity-50 text-16 lg-max:hidden'>Contact</div>
									<div className='lg-max:mb-22'>{company.contact}</div>
								</div>}
							{company.phone &&
								<div className='flex flex-col lg:mr-30'>
									<div className='mb-12 opacity-50 text-16 lg-max:hidden'>Phone</div>
									<div className='lg-max:mb-22'>{company.phone}</div>
								</div>}
							<div className='flex flex-col lg:mr-30'>
								<div className='mb-12 opacity-50 text-16 lg-max:hidden'>Socials</div>
								<div className='flex lg-max:mb-22 md-max:mx-auto'>
									{company.socialLinks?.map((item, idx) => (
										<Link href={item.url} key={idx} className='w-24 h-24 mr-16 last:mr-0'>
											<SocialsLogo {...item} />
										</Link>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>}
		</div>
	)
}
